// Build the encounter nav state for a calendar→encounter navigation (PROD-1254): find the
// loaded appointment row and map it to EncounterPatientNav — carrying patient · demographics ·
// specialtyId · encounterId · appointmentStart/End (the slot PROD-1246 Reschedule needs).
// Mirrors what todays-appointments-page already does on its entry; returns undefined when the
// row isn't in the loaded set, so the encounter page falls back to GET-by-appointment.
import type { ListAppointmentItem } from '@/types/appointment-api';
import { toEncounterNav, type EncounterPatientNav } from '@/encounter/lib/to-patient-header';

export function encounterNavStateFor(
  appointments: ListAppointmentItem[] | undefined,
  appointmentId: string,
): EncounterPatientNav | undefined {
  const item = appointments?.find((a) => a.id === appointmentId);
  return item ? toEncounterNav(item) : undefined;
}
